import $ from 'jquery';

const navigation = {
    init() {
        $(document).ready(() => {
            this.setupNavigation();
        });
    },
    setupNavigation() {
        $(document).on('click', '.more-menu', (e) => {
            $(e.currentTarget).parent().find('.sub-menu').toggleClass('show');
        });
    },
};

export default navigation;
